import {VisualArtifactRef} from '@mintdata-wsp/common/state/ui/visualDesigner/artifacts/VisualArtifactRef';
import {VisualComponentRef} from '@mintdata-wsp/common/state/ui/visualDesigner/artifacts/VisualComponentRef';
import {
    getComponentsSectionName,
    VisualComponentsSectionName
} from '@mintdata-wsp/common/state/ui/visualDesigner/SurfaceEditorState';

export type VisualComponentId = string;

export class VisualComponent
{
    public readonly visualArtifactRef:VisualArtifactRef;
    public readonly ref:VisualComponentRef;
    public readonly name:string;
    public readonly description:any;

    public readonly section:VisualComponentsSectionName;

    public readonly getReactClassCtor:() => Promise<React.ComponentClass<any>>;

    public constructor(visualArtifactRef:VisualArtifactRef,
                       ref:VisualComponentRef,
                       name:string,
                       description:any,
                       getReactClassCtor?:() => Promise<React.ComponentClass<any>>)
    {
        this.visualArtifactRef = visualArtifactRef;
        this.ref = ref;
        this.name = name;
        this.description = description;

        const sectionGroupName:VisualComponentsSectionName = getComponentsSectionName(name);
        this.section = sectionGroupName || VisualComponentsSectionName.NoGroup;

        this.getReactClassCtor = getReactClassCtor;
    }

    public get id():VisualComponentId
    {
        return VisualComponent.idFrom(this.visualArtifactRef, this.name);
    }

    public static idFrom(vaRef:VisualArtifactRef, name:string)
    {
        return `${vaRef.organization}:${vaRef.name}:${name}`;
    }
}

export class LocalComponentDef
{
    public static PREFIX = `@mintdata/mint-components/components`;

    public constructor(public aModule, public definedBy:string, public exportName:string)
    {
    }
}
